export default "__VITE_ASSET__5deNwYMy__"